import { Route } from 'react-router-dom'
import Error404 from '../views/error/Error404'

const routes = [<Route key={'error-404'} path="*" element={<Error404 />} />]

export default routes